import { render, staticRenderFns } from "./CategoryInput.vue?vue&type=template&id=262c08f4&lang=pug"
import script from "./CategoryInput.vue?vue&type=script&lang=ts"
export * from "./CategoryInput.vue?vue&type=script&lang=ts"
import style0 from "./CategoryInput.vue?vue&type=style&index=0&id=262c08f4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Sel: require('/app/components/vantone/Sel.vue').default,Icon: require('/app/components/vantone/Icon.vue').default,AvSelect: require('/app/components/anyvan/AvSelect.vue').default})
